import React, { useContext } from "react";

import { useCurrentServer } from "providers/WithCurrentOrganization";

import {
  CurrentServerDetailsQuery,
  useCurrentServerDetailsQuery,
} from "./gql/Query.generated";

type CurrentServerDetailsType = CurrentServerDetailsQuery["getServerDetails"];

const CurrentServerDetailsContext = React.createContext<
  CurrentServerDetailsType | undefined
>(undefined);

// Loads details of the currently selected server that are too expensive to
// fetch for all servers at once in WithCurrentOrganization. Unlike
// WithCurrentOrganization, this does not block rendering while the data loads:
// useCurrentServerDetails() returns undefined until the data is available, or
// when there is no current server.
const WithCurrentServer = ({ children }: { children: React.ReactNode }) => {
  const server = useCurrentServer(true);
  const { data } = useCurrentServerDetailsQuery({
    variables: {
      // N.B.: server *can* be null here, but if it's present,
      // it definitely has a humanId, hence the assertion
      // eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain
      serverId: server?.humanId!,
    },
    skip: server == null,
  });

  return (
    <CurrentServerDetailsContext.Provider value={data?.getServerDetails}>
      {children}
    </CurrentServerDetailsContext.Provider>
  );
};

export function useCurrentServerDetails():
  | CurrentServerDetailsType
  | undefined {
  return useContext(CurrentServerDetailsContext);
}

export default WithCurrentServer;
